module.exports = __webpack_public_path__ + "static/media/5_viewer_realtime.59434d76.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/5_viewer_realtime.mp4
// module id = 319
// module chunks = 0